import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Package } from "lucide-react";
import { Steps } from "./Checkout";

export default function OrderSuccess() {
  const order = JSON.parse(sessionStorage.getItem("nt_last_order") || "null");

  return (
    <div data-testid="page-order-success" className="bg-[var(--bg)] pt-[110px] md:pt-[120px] pb-20 min-h-screen">
      <div className="max-w-[760px] mx-auto px-6 md:px-10">
        <Steps current={4} />
        <div className="card-soft p-8 md:p-12 text-center mt-8">
          <div className="w-16 h-16 rounded-full bg-[var(--green)] flex items-center justify-center mx-auto"><CheckCircle2 size={32} className="text-white" /></div>
          <h1 className="font-serif-display text-3xl md:text-5xl mt-6 font-semibold text-[var(--ink)]">Thank you!</h1>
          <p className="text-[var(--ink-2)] mt-4 max-w-md mx-auto">Your order has been placed. A confirmation email is on its way.</p>

          {order && (
            <div className="mt-8 inline-flex flex-col md:flex-row gap-3 md:gap-6 bg-[var(--bg-cream)] rounded-xl p-5">
              <div><div className="kbd text-[var(--ink-3)] text-[0.6rem]">Order ID</div><div className="font-serif-display text-lg font-semibold text-[var(--green)]" data-testid="order-id">{order.id}</div></div>
              <div className="hidden md:block w-px bg-[var(--line)]" />
              <div><div className="kbd text-[var(--ink-3)] text-[0.6rem]">Amount paid</div><div className="font-serif-display text-lg font-semibold text-[var(--green)]">₹{order.total}</div></div>
              <div className="hidden md:block w-px bg-[var(--line)]" />
              <div><div className="kbd text-[var(--ink-3)] text-[0.6rem]">Method</div><div className="font-serif-display text-lg font-semibold uppercase">{order.method}</div></div>
            </div>
          )}

          <div className="mt-9 flex flex-wrap gap-3 justify-center">
            <Link to="/account/orders" data-testid="success-view-orders" className="btn-primary">View My Orders <ArrowRight size={14} /></Link>
            <Link to="/products" data-testid="success-continue" className="btn-outline">Continue Shopping</Link>
            <Link to="/" data-testid="success-home" className="btn-outline">Back to Home</Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-2 text-xs text-[var(--ink-3)]"><Package size={14} /> Estimated delivery in 3-5 business days</div>
        </div>
      </div>
    </div>
  );
}
